import { render, staticRenderFns } from "./PointCreditTelecom.vue?vue&type=template&id=19039510"
import script from "./PointCreditTelecom.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports